import React from "react";

import {User} from "features/admin/types";
import {Role} from "features/auth";

const UserDetailsCard = ({user: {last_ip, login, role, user_id}}: { user: User }) => {
    return (
        <div className="category-details-card">
            <div className="cat-id-wrapper">
                <p className="cat-info-id">ID: {user_id}</p>
            </div>
            <div className="cat-main-info-wrapper">
                <p className="cat-info-name">{login}</p>
                <p className="cat-info-status">{Role[role]}</p>
            </div>
            <div className="cat-dates-info-wrapper">
                <p className="cat-date-info">Last login IP: {last_ip}</p>
            </div>
        </div>
    );
};

export default UserDetailsCard;